/**
 * 商品企画マスタ画面　選定確認処理リクエスト用VOクラス
 */
export class KYMW1300CheckRegistPlanModel {

    public mediumType: string = null;                                             // 媒体区分
    public sellAreaCode: string = null;                                           // 売り場コード
    public orderNumQuotaCode: string = null;                                      // 注文コード割当コード
    public orderCodeList: Array<string> = new Array<string>();                    // 受注コードリスト
    public RegistPlanPCodeList: Array<string> = new Array<string>();              // Ｐコードリスト
    public featureCode: string = null;                                            // 特集コード
  
  }
  